module.exports = __webpack_public_path__ + "img/auto_checkin.50b43f4c.png";